// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 3: ישוע המשיח
// ============================================================================
// Levels 27-39 (13 רמות, 39 שאלות)

export const chapter3Translations = {
  name: 'ישוע המשיח',
  description: 'והדבר נהיה בשר... להכיר את המשיח הוא חיי עולם',
  
  spiritualWisdom: {
    principle: 'להכיר את ישוע המשיח הוא חיי עולם',
    scripture: 'וזאת היא חיי העולם: להכיר אותך, האלוהים האמיתי היחיד, ואת ישוע המשיח אשר שלחת (יוחנן 17:3)',
    application: 'כל היבט מחיי ישוע מגלה את אלוהים ומזין את נשמתנו לנצח'
  },
  
  levels: {
    27: {
      name: 'הבשורה',
      challenge: 'המלאך גבריאל נשלח מאת אלוהים אל עיר בגליל...',
      easy: {
        question: 'איזה מלאך בשר למרים שהיא תלד את ישוע?',
        options: ['מיכאל', 'גבריאל', 'רפאל', 'אוריאל'],
        hint: 'המלאך שליח אלוהים',
        funFact: '👼 גבריאל פירושו כוח אלוהים - מלאך ההכרזות הגדולות!'
      },
      medium: {
        question: 'מה הייתה תגובתה הראשונה של מרים לבשורה זו?',
        options: [
          'שמחה מיידית',
          'חוסר אמונה מוחלט',
          'בלבול והשאלה איך יהיה זה?',
          'פחד'
        ],
        hint: 'שאלה מעשית ולגיטימית',
        funFact: '🤔 מרים שואלת שאלה הגיונית אך שומרת על לב פתוח לאלוהים!'
      },
      hard: {
        question: 'מה מלמדת אותנו כניעת מרים לרצון האלוהי?',
        options: [
          'פסיביות מול ניסיונות',
          'אמונה שסומכת גם מבלי להבין הכל',
          'ציות עיוור',
          'השלמה'
        ],
        hint: 'מדובר בלסמוך על אלוהים גם בלתי נודע',
        funFact: '🙏 יהי לי כדברך - מודל של אמונה בוטחת!'
      }
    },
    
    28: {
      name: 'הלידה',
      challenge: 'והיא ילדה את בנה הבכור, ותחתלהו ותשכיבהו באבוס...',
      easy: {
        question: 'באיזו עיר נולד ישוע?',
        options: ['נצרת', 'ירושלים', 'בית לחם', 'כפר נחום'],
        hint: 'עיר דוד',
        funFact: '🏘️ בית לחם פירושו בית הלחם - ישוע, לחם החיים!'
      },
      medium: {
        question: 'מי היו הראשונים לקבל את בשורת הלידה?',
        options: [
          'החכמים',
          'הרועים בשדה',
          'כוהני המקדש',
          'משפחת מרים'
        ],
        hint: 'אנשים פשוטים ששמרו על עדריהם',
        funFact: '🐑 אלוהים מבשר תחילה לרועים הענווים - הבשורה לכולם!'
      },
      hard: {
        question: 'מה מסמל ישוע שנולד באבוס?',
        options: [
          'העוני של הוריו',
          'ענוותנותו של אלוהים שמתכופף אלינו',
          'חוסר המקום',
          'הפשטות הכפרית'
        ],
        hint: 'מדובר בהתגלמות האלוהית בענווה',
        funFact: '👶 בורא היקום נולד ברפת - אהבה אינסופית!'
      }
    },

    29: {
      name: 'החכמים מן המזרח',
      challenge: 'חכמים מן המזרח באו לירושלים ושאלו...',
      easy: {
        question: 'מה הדריך את החכמים אל ישוע?',
        options: ['מלאך', 'כוכב', 'חזון', 'מפה'],
        hint: 'גרם שמיים בשמים',
        funFact: '⭐ הכוכב מייצג את ישוע כאור העמים!'
      },
      medium: {
        question: 'אילו מתנות הביאו החכמים?',
        options: [
          'מזון',
          'זהב, לבונה ומור',
          'בגדים יקרים',
          'צעצועים'
        ],
        hint: 'שלוש מתנות סמליות ויקרות',
        funFact: '🎁 זהב (מלכות), לבונה (אלוהות), מור (קורבן) - כל שליחותו של ישוע!'
      },
      hard: {
        question: 'מה מייצגים החכמים הגויים הללו בתכנית אלוהים?',
        options: [
          'עליונות דתות אחרות',
          'אוניברסליות הישועה המוצעת לכל העמים',
          'עושר חומרי',
          'מדע עתיק'
        ],
        hint: 'מדובר בפתיחת הישועה לכל האומות',
        funFact: '🌍 החכמים מקדימים את הבשורה שתגיע לכל העולם!'
      }
    },

    30: {
      name: 'טבילתו של ישוע',
      challenge: 'כשנטבל ישוע, עלה מיד מן המים...',
      easy: {
        question: 'מי הטביל את ישוע?',
        options: ['פטרוס', 'יוחנן המטביל', 'אנדריאס', 'יעקב'],
        hint: 'המבשר של ישוע',
        funFact: '🌊 יוחנן המטביל חשב שאינו ראוי להתיר את שרוכי נעלי ישוע!'
      },
      medium: {
        question: 'מה ירד על ישוע בטבילתו?',
        options: [
          'אור',
          'יונה (רוח הקודש)',
          'מלאך',
          'רק קול'
        ],
        hint: 'הציפור סמל השלום',
        funFact: '🕊️ היונה מגלה את המשיחה האלוהית לתחילת השירות!'
      },
      hard: {
        question: 'מדוע ישוע, חף מחטא, הטביל את עצמו?',
        options: [
          'כדי לתת דוגמה',
          'כדי למלא כל צדקה ולהזדהות איתנו',
          'בגלל חובה דתית',
          'כדי לקבל סליחה'
        ],
        hint: 'מדובר בסולידריות עם האנושות החוטאת',
        funFact: '❤️ ישוע מזדהה לחלוטין איתנו כדי להושיע אותנו טוב יותר!'
      }
    },

    31: {
      name: 'הניסיון במדבר',
      challenge: 'ישוע הובל על ידי הרוח אל המדבר להתנסות על ידי השטן...',
      easy: {
        question: 'כמה זמן צם ישוע במדבר?',
        options: ['30 יום', '40 יום', '50 יום', '60 יום'],
        hint: 'המספר המקראי של הניסיון',
        funFact: '🏜️ כמו משה ואליהו, 40 יום של הכנה רוחנית אינטנסיבית!'
      },
      medium: {
        question: 'איך דחה ישוע כל ניסיון?',
        options: [
          'בכוחו העצמי',
          'על ידי ציטוט הכתובים',
          'על ידי התעלמות מהשטן',
          'רק על ידי תפילה'
        ],
        hint: 'הנשק הרוחני המצוין ביותר',
        funFact: '📖 כתוב... - דבר אלוהים, חרב הרוח!'
      },
      hard: {
        question: 'מה מלמד אותנו ניסיונו של ישוע על מאבקינו?',
        options: [
          'ניסיונות הם חטא',
          'ניסיון יכול להיכבש על ידי הדבר והאמונה',
          'יש לברוח מכל מדבר',
          'רק ישוע יכול לעמוד'
        ],
        hint: 'מדובר באסטרטגיה שלנו מול ניסיונות',
        funFact: '⚔️ ישוע מראה לנו איך לנצח: דבר אלוהים + אמונה פעילה!'
      }
    },

    32: {
      name: 'התלמידים הראשונים',
      challenge: 'ישוע אמר להם: לכו אחרי ואעשה אתכם לדייגי אנשים...',
      easy: {
        question: 'מה היה מקצועם של פטרוס ואנדריאס?',
        options: ['רועים', 'דייגים', 'נגרים', 'מוכסים'],
        hint: 'מקצוע בכנרת',
        funFact: '🎣 ישוע הופך דייגי דגים לדייגי נשמות!'
      },
      medium: {
        question: 'איך הגיבו התלמידים הראשונים לקריאה?',
        options: [
          'הם היססו זמן רב',
          'הם דרשו הוכחות',
          'הם עזבו הכל והלכו אחריו מיד',
          'הם התמקחו'
        ],
        hint: 'תגובה מיידית ומוחלטת',
        funFact: '🚶 סמכותו של ישוע הייתה כה ברורה שהם ציית�� מיד!'
      },
      hard: {
        question: 'מה משמעותו ללכת אחרי ישוע בזמננו?',
        options: [
          'לעזוב את העבודה',
          'לחיות לפי תורותיו ורצונו',
          'להצטרף לקהילה מבודדת',
          'רק לבשר'
        ],
        hint: 'מדובר בשינוי חיים ועדיפויות',
        funFact: '✨ ללכת אחרי ישוע משנה את ליבנו, בחירותינו, ייעודנו!'
      }
    },

    33: {
      name: 'הדרשה על ההר',
      challenge: 'אשרי עניי הרוח, כי להם מלכות השמים...',
      easy: {
        question: 'מהי האשרה הראשונה בדרשה על ההר?',
        options: [
          'אשרי נקי הלב',
          'אשרי עניי הרוח',
          'אשרי הענוים',
          'אשרי רודפי השלום'
        ],
        hint: 'מתייחסת לענווה רוחנית',
        funFact: '😊 עניי הרוח יודעים את צורכם באלוהים - שער למלכות!'
      },
      medium: {
        question: 'מה אמר ישוע על רודפי השלום?',
        options: [
          'הם יהיו בני מזל',
          'הם ייקראו בני אלוהים',
          'הם יהיו אהובים',
          'הם יהיו חזקים'
        ],
        hint: 'זהות אלוהית מיוחדת',
        funFact: '👑 רודפי שלום דומים לאלוהים - עדות חיה לטבעו!'
      },
      hard: {
        question: 'איך האשרות הופכות את ערכי העולם?',
        options: [
          'על ידי גינוי העושר',
          'על ידי בידוד המאמינים',
          'על ידי הכרזת ברכה על מי שהעולם בז להם',
          'על ידי ביטול החוקים'
        ],
        hint: 'מדובר בערכים אלוהיים מנוגדים לערכים עולמיים',
        funFact: '🔄 האשרות משנות את ראייתנו לאושר והצלחה!'
      }
    },

    34: {
      name: 'משלי המלכות',
      challenge: 'הוא לימד אותם דברים רבים במשלים...',
      easy: {
        question: 'במשל הזורע, מה מייצג הזרע?',
        options: [
          'כסף',
          'דבר אלוהים',
          'מעשים טובים',
          'אהבה'
        ],
        hint: 'מה שישוע מכריז ומלמד',
        funFact: '🌱 דבר אלוהים נובט וגדל בליבותינו!'
      },
      medium: {
        question: 'במשל גרגר החרדל, מה מסמל הזרע הקטן הזה?',
        options: [
          'חולשה אנושית',
          'המלכות שמתחילה קטנה אך נעשית גדולה',
          'חשיבות הפרטים',
          'הטבע'
        ],
        hint: 'משהו שגדל בצורה מרשימה',
        funFact: '🌳 מהזרע הקטן ביותר נולד עץ גדול - כוח המלכות!'
      },
      hard: {
        question: 'מדוע ישוע לימד במשלים?',
        options: [
          'כדי לסבך את המסר שלו',
          'כדי לגלות אמיתות רוחניות דרך דימויים מוכרים',
          'בגלל חוסר זמן',
          'כדי לבדוק אינטליגנציה'
        ],
        hint: 'מדובר בהנגשת סודות המלכות',
        funFact: '💡 המשלים מגלים ללבבות פתוחים ומסתירים מלבבות סגורים!'
      }
    },

    35: {
      name: 'ניסי ישוע',
      challenge: 'הוא השקיט את הרוח ואמר לים: שקט! היה דום!...',
      easy: {
        question: 'בכמה כיכרות לחם האכיל ישוע 5000 איש?',
        options: ['3 כיכרות', '5 כיכרות', '7 כיכרות', '12 כיכרות'],
        hint: 'אותו מספר כמו הדגים',
        funFact: '🍞 5 כיכרות ו-2 דגים הופכים למשתה - נדיבות אלוהית!'
      },
      medium: {
        question: 'מה אמרו התלמידים כשישוע השקיט את הסערה?',
        options: [
          'הוא קוסם',
          'מי זה שאפילו הרוח והים נשמעים לו?',
          'זה נורמלי',
          'עלינו לעזוב מכאן'
        ],
        hint: 'שאלה על זהותו של ישוע',
        funFact: '⛈️ אפילו היסודות מכירים בבוראם ואדונם!'
      },
      hard: {
        question: 'מה המטרה העיקרית של ניסיו של ישוע?',
        options: [
          'להרשים את ההמונים',
          'לגלות את אלוהותו ולהפגין את אהבת אלוהים',
          'לזכות בהשפעה',
          'לעזור רק חומרית'
        ],
        hint: 'מדובר בגילוי אלוהי ורחמים',
        funFact: '❤️ כל נס מגלה את לב אלוהים: אהבה, רחמים, כוח!'
      }
    },

    36: {
      name: 'ההשתנות',
      challenge: 'והוא השתנה לפניהם, ופניו האירו כשמש...',
      easy: {
        question: 'אילו תלמידים ראו את ישוע משתנה?',
        options: [
          'כל השנים עשר',
          'פטרוס, יעקב ויוחנן',
          'רק פטרוס ויוחנן',
          'הנשים שהלכו אחריו'
        ],
        hint: 'המעגל הפנימי של השלושה',
        funFact: '⛰️ פטרוס, יעקב ויוחנן: עדים מיוחדים לכבוד האלוהי!'
      },
      medium: {
        question: 'אילו דמויות מהברית הישנה הופיעו?',
        options: [
          'אברהם ויצחק',
          'דוד ושלמה',
          'משה ואליהו',
          'אדם ונח'
        ],
        hint: 'נציג התורה ונציג הנביאים',
        funFact: '📜 משה (תורה) ואליהו (נביאים) מעידים על ישוע!'
      },
      hard: {
        question: 'מה מגלה ההשתנות הזו על טבעו של ישוע?',
        options: [
          'הוא נביא גדול',
          'אלוהותו הנסתרת מתגלה באופן זמני',
          'הוא שולט באור',
          'הוא יכול לשנות מראה'
        ],
        hint: 'מדובר בגילוי טבעו האלוהי',
        funFact: '✨ הכבוד האלוהי של ישוע זורח - הצצה לתחייתו!'
      }
    },

    37: {
      name: 'הכניסה המנצחת',
      challenge: 'הושענא לבן דוד! ברוך הבא בשם ה\'!...',
      easy: {
        question: 'על איזו בהמה נכנס ישוע לירושלים?',
        options: ['סוס', 'חמור', 'גמל', 'ברגל'],
        hint: 'בעל חיים סמל לענווה ושלום',
        funFact: '🐴 החמור מסמל את המלך הענו הבא בשלום, לא במלחמה!'
      },
      medium: {
        question: 'מה זעק הקהל בקבלו את ישוע?',
        options: [
          'יחי המלך!',
          'הושענא! ברוך הבא בשם ה\'!',
          'כבוד לאלוהים!',
          'חירות!'
        ],
        hint: 'זעקת שמחה וברכה',
        funFact: '🌿 "הושענא" משמעו "הושע נא" - קריאה לישועה אלוהית!'
      },
      hard: {
        question: 'מדוע הכניסה הזו "מנצחת" אך טראגית?',
        options: [
          'היו מעט אנשים',
          'ההמון שמקבל אותו בשמחה ידחה אותו בעוד 5 ימים',
          'הרשויות נעדרו',
          'ירד גשם'
        ],
        hint: 'מדובר בחוסר עקביות הלב האנושי',
        funFact: '💔 אותו המון יזעק "צלוב אותו!" כעבור ימים ספורים!'
      }
    },

    38: {
      name: 'הסעודה האחרונה',
      challenge: 'קחו ואכלו, זה הוא גופי הניתן בעדכם...',
      easy: {
        question: 'מה עשה ישוע לרגלי תלמידיו?',
        options: [
          'ברך אותן',
          'רחץ אותן',
          'בישם אותן',
          'נישק אותן'
        ],
        hint: 'מחוות ענווה ושירות',
        funFact: '🦶 המורה הופך למשרת - מהפכת אהבה וענווה!'
      },
      medium: {
        question: 'מה הקים ישוע בסעודה זו?',
        options: [
          'את הטבילה',
          'את הסעודה הקדושה (הקודש)',
          'את תפילת אבינו שבשמים',
          'את הצום'
        ],
        hint: 'מצוות עם לחם ויין',
        funFact: '🍞🍷 לחם ויין הופכים לסמלים נצחיים של קורבן ואהבה!'
      },
      hard: {
        question: 'מה משמעותו "עשו זאת לזכרי"?',
        options: [
          'חזרו על הסעודה הזו',
          'חגגו את מותי ותחייתי עד שאחזור',
          'זכרו את דברי',
          'אהבו זה את זה'
        ],
        hint: 'מדובר בהנצחה חיה ונבואית',
        funFact: '⏳ כל קידוש מבשר את מות האדון עד שובו!'
      }
    },

    39: {
      name: 'גת שמנים',
      challenge: 'אבי, אם אפשר, תעבור ממני הכוס הזאת...',
      easy: {
        question: 'איפה התפלל ישוע לפני מעצרו?',
        options: [
          'בבית המקדש',
          'בגן גת שמנים',
          'על הר הזיתים',
          'בבית חבריו'
        ],
        hint: 'גן של עצי זית',
        funFact: '🫒 גת שמנים פירושו "בית בד לשמן" - מקום לחץ עז!'
      },
      medium: {
        question: 'מה עשו התלמידים בזמן שישוע התפלל?',
        options: [
          'התפללו איתו',
          'נרדמו',
          'עמדו על המשמר',
          'עזבו'
        ],
        hint: 'לא יכלו לשקוד שעה אחת',
        funFact: '😴 הרוח חפצה אך הבשר חלש - חולשה אנושית!'
      },
      hard: {
        question: 'מה מגלה עינויו של ישוע על טבעו?',
        options: [
          'הוא היה רק אדם',
          'הוא היה אדם מלא ואלוהים מלא',
          'הוא פקפק בשליחותו',
          'הוא היה חלש'
        ],
        hint: 'מדובר בסוד ההתגלמות',
        funFact: '✝️ ישוע נושא את החרדה האנושית במלואה תוך שהוא נשאר נאמן לאלוהים!'
      }
    }
  }
};

export default chapter3Translations;
